"use client";
import React from 'react';
import './Footer.css';
import ssn_img from '../../assets/img/ssn.png';
import play_store from '../../assets/img/google-play-1.png';
import app_store from '../../assets/img/app-store-1.png';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#808080] text-sm w-full mt-14 text-white">
      {/* parte superior */}
      <div className="w-full py-8 px-4 md:px-16 grid md:grid-cols-4 md:justify-between md:items-start text-center md:text-left gap-8">
        {/* logo y redes */}
        <div className="flex flex-col items-center md:items-start gap-4">
          <div className="w-24 h-10 bg-gray-400 hidden md:block" /> {/* logo placeholder */}
          <div className="gap-4 mt-2 hidden md:flex">
            <div className="w-6 h-6 bg-gray-400 rounded-full" />
            <div className="w-6 h-6 bg-gray-400 rounded-full" />
            <div className="w-6 h-6 bg-gray-400 rounded-full" />
            <div className="w-6 h-6 bg-gray-400 rounded-full" />
          </div>
          <p className="mt-2">Descargar la App</p>
          <div className="hidden md:flex gap-2">
            <div>
              <Link to={'https://play.google.com/store/apps/details?id=dibi.atmseguros&hl=es_AR'} target='_blank'>
                <img src={play_store} alt='google_play_store' className='w-[50px] h-[50px]' />
              </Link>
            </div>
            <div>
              <Link to={'https://apps.apple.com/ar/app/atm-seguros/id1433020350'} target='_blank'>
                <img src={app_store} alt='app_store' className='w-[50px] h-[50px]' />
              </Link>
            </div>
          </div>
          <p className="mt-4">© {new Date().getFullYear()} ATM SEGUROS</p>
        </div>

        {/* links */}
        <div className="flex flex-col gap-2 font-semibold">
          <p>Nosotros</p>
          <Link to='https://atmseguros.com.ar/quienes-somos/' target='_blank' className="font-normal">¿Quiénes Somos?</Link>
          <Link to='https://atmseguros.com.ar/novedades/' target='_blank' className="font-normal">Novedades</Link>
          <Link to='https://atmseguros.com.ar/donde-estamos/' target='_blank' className="font-normal">¿Dónde estamos?</Link>
          <Link to='https://atmseguros.com.ar/sumate-al-equipo/' target='_blank' className="font-normal">Sumate al equipo</Link>
        </div>
        <div className="flex flex-col gap-2 font-semibold">
          <p>Compromiso</p>
          <Link to='https://atmseguros.com.ar/compromiso/#consejos-para-asegurados' target='_blank' className="font-normal">Consejos para asegurados</Link>
          <Link to='https://atmseguros.com.ar/compromiso/#servicio-de-atencion-al-asegurado' target='_blank' className="font-normal">Servicio de Atención al Asegurado</Link>
          <Link to='https://atmseguros.com.ar/lucha-contra-el-fraude/' target='_blank' className="font-normal">Lucha contra el Fraude</Link>
          <Link to='https://atmseguros.com.ar/compromiso/#prevencion-lavado' target='_blank' className="font-normal">Prevención Lavado de Activos</Link>
        </div>
        <div className="flex flex-col gap-2 font-semibold ms-3">
          <p>Información Útil</p>
          <Link to='https://atmseguros.com.ar/#' target='_blank' className="font-normal">Atención al asegurado</Link>
          <Link to='https://atmseguros.com.ar/contacto/' target='_blank' className="font-normal">Contacto</Link>
          <Link to='https://atmseguros.com.ar/atencion-al-cliente/medios-de-pago/' target='_blank' className="font-normal">Pagar mis seguros</Link>
          <Link to='https://atmseguros.com.ar/siniestros/' target='_blank' className="font-normal">Denunciar un siniestro</Link>
          <Link to='https://siniestros.atmseguros.com.ar/' target='_blank' className="font-normal">Reclamo de Terceros</Link>
          <Link to='https://atmseguros.com.ar/quiero-ser-pas-atm/' target='_blank' className="font-normal">Quiero ser PAS ATM</Link>
          <Link to='https://ecommerce.atmseguros.com.ar/baja' target='_blank' className="font-normal">Botón de arrepentimiento</Link>
          <Link to='https://atmseguros.com.ar/politicaprivacidad/' target='_blank' className="font-normal">Política privacidad</Link>
        </div>
      </div>
      <div className='w-full flex lg:flex-row flex-col items-center justify-between border-t-[3px] border-t-light-grey'>
        <div className='xl:w-[65%] lg:w-[70%] w-full flex flex-col items-center justify-between'>
          <div className='w-full bg-white'>
            <div className='xl:w-10/12 2xl:w-11/12 w-10/12 h-full flex justify-between mx-auto items-baseline flex-col'>
              <div className="grid md:hidden grid-cols-2 text-black text-xs font-normal leading-tight py-6">
                <div className="flex flex-col text-center items-center justify-between gap-y-6 h-full">
                  <p>Nº de Inscripción SSN<br />0812</p>
                  <a href='tel:8006668400' target='_blank' rel='noreferrer' className='font-bold md:text-base text-sm text-blue'>0800-666-8400</a>
                </div>
                <div className="flex flex-col text-center items-center justify-between gap-y-6 h-full">
                  <p>Departamento de Orientación<br />y Asistencia al Asegurado</p>
                  <Link to='https://www.argentina.gob.ar/ssn' target='_blank' className='font-bold md:text-base text-sm text-blue'>www.argentina.gob.ar/ssn</Link>
                </div>
              </div>
              <div className="hidden md:flex flex-row text-black text-xs font-normal leading-tight items-center w-full justify-between md:py-6">
                <div className="flex flex-row">
                  <p className='text-center'>Nº de Inscripción SSN<br />0812</p>
                </div>
                <div className='3sm:bg-grey 3sm:w-[1px] 3sm:h-8 hidden md:block md:mx-4'></div>
                <div className="flex flex-row gap-x-8 xl:gap-x-16">
                  <p className='text-center'>Departamento de Orientación<br />y Asistencia al Asegurado</p>
                  <a href='tel:8006668400' target='_blank' rel='noreferrer' className='font-bold md:text-base text-sm text-blue'>0800-666-8400</a>
                </div>
                <div className='3sm:bg-grey 3sm:w-[1px] 3sm:h-8 hidden md:block md:mx-4'></div>
                <div className="flex flex-row">
                  <Link to='https://www.argentina.gob.ar/ssn' target='_blank' className='font-bold md:text-base text-sm text-blue'>www.argentina.gob.ar/ssn</Link>
                </div>
              </div>
            </div>
          </div>
          <div className='w-full bg-neutral py-8'>
            <div className='xl:w-10/12 2xl:w-11/12 w-10/12 h-full flex justify-between items-center flex-col mx-auto'>
              <div className='h-auto py-3 md:py-0 w-full flex justify-between items-center'>
                <div className='flex w-full flex-col h-full justify-center items-center text-left text-black text-xs font-normal leading-tight gap-4'>
                  <div>La entidad aseguradora dispone de un Servicio de Atención al Asegurado que atenderá las consultas y reclamos que presenten los tomadores de seguros, asegurados, beneficiarios y/o derechohabientes.</div>
                  <div>En caso de que existiera un reclamo ante la entidad aseguradora y que el mismo no haya sido resuelto o haya sido desestimado, total o parcialmente, o que haya sido denegada su admisión, podrá comunicarse con la Superintendencia de Seguros de la Nación por teléfono al 0800-666-8400, correo electrónico a consultas@ssn.gob.ar o formulario disponible en la página argentina.gob.ar/ssn</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='xl:w-[35%] lg:w-[30%] w-full h-full flex flex-col items-center justify-between bg-white xl:px-20 px-10'>
          <a href='https://www.argentina.gob.ar/ssn' target='_blank' rel='noreferrer'><img src={ssn_img} alt='SSN IMG' className='w-[242px] py-6' /></a>
          <div className='flex w-full pb-5 flex-col h-full justify-between items-left text-left text-black text-xs font-normal leading-tight'>
            El Servicio de Atención al Asegurado (SAA) está integrado por:
            <span className='py-2'></span>
            RESPONSABLE Fernando Rodríguez<br />
            SUPLENTE Paola Candia
            <span className='py-2'></span>
            <span>EMAIL <a href="mailto:saa@atmseguros.com.ar" target="_blank" rel="noreferrer">saa@atmseguros.com.ar</a></span>
            <span>TELÉFONO <a href="tel:+5491152390230" target='_blank' rel='noreferrer'>1152390230</a></span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;